import store from '../../../store'
// import { conditionalFilterMaps } from '../../../utils/filterUtils'

export async function sendEvent (socket, event, payload) {
  return

  // ================================
  // INFO: Disabled until we have a use for it. We will need to update it for the new filter system.
  // ================================

  // // Get user from Vuex store instead of Firebase directly
  // const user = store.getters['AuthModule/getUser']
  // const team = store.getters['AuthModule/getTeam']

  // // Get current route from global state
  // const location = store.getters['RouterModule/getCurrentRoute']
  // const currentParams = store.getters['RouterModule/getCurrentParams']

  // // Get current filters and search from global state
  // const currentFilters = store.getters['SearchModule/getCurrentFilters']
  // const currentTextSearch = store.getters['SearchModule/getCurrentTextSearch']

  // const formattedFilters = Object.keys(currentFilters).reduce((formattedOrFilters, filterKey) => {
  //   if (!currentFilters[filterKey]?.length) {
  //     // Add it directly to the object
  //     formattedOrFilters[filterKey] = null
  //     return formattedOrFilters
  //   } if (filterKey === 'textSearch') {
  //     formattedOrFilters[filterKey] = currentFilters[filterKey]
  //     return formattedOrFilters
  //   }
  //   const { value, transform } = conditionalFilterMaps.or[filterKey]

  //   currentFilters[filterKey].forEach(filter => {
  //     if (formattedOrFilters[filterKey]) {
  //       formattedOrFilters[filterKey].push(transform(filter[value]))
  //     } else {
  //       formattedOrFilters[filterKey] = [transform(filter[value])]
  //     }
  //   })

  //   return formattedOrFilters
  // }, {})

  // const eventPayload = {
  //   event,
  //   userId: user ? user.token : null,
  //   teamId: team ? team.id : null,
  //   // This may be overwritten by the payload
  //   brandId: location === 'BrandView' ? currentParams?.id : null,
  //   location,
  //   filters: formattedFilters,
  //   ...payload
  // }

  // eventPayload.filters.textSearch = currentTextSearch
  // console.log('Sending event', eventPayload)

  // // Send event
  // socket.emit('event', eventPayload)


  // ================================
  // INFO: Older reference code from where the vuex store was updated (from <FilterTopBar> in emitUpdate())
  // emitString could be something like 'update:selectedBoards', 'update:selectedFormats', etc.
  // ================================

  // const { emitString, items } = emitObject

  // Update Search State with the proper items
  // this.SET_CURRENT_TEXT_SEARCH(this.textSearch)

  // const filterUpdatePayload = {
  //   publisher_platform: this.selectedPlatforms,
  //   formats: this.selectedFormats,
  //   niches: this.selectedNiches,
  //   contentFilters: this.selectedContentFilters,
  //   marketTarget: this.selectedMarketTargets,
  //   languages: this.selectedLanguages || [],
  //   liveStatus: this.liveStatus,
  //   textSearch: this.textSearch,
  //   favoriteFilter: this.favoriteFilter || false
  // }

  // // Map the emit string to the correct payload key
  // const keyMap = {
  //   selectedPlatforms: 'publisher_platform',
  //   selectedFormats: 'formats',
  //   selectedNiches: 'niches',
  //   selectedContentFilters: 'contentFilters',
  //   selectedMarketTargets: 'marketTarget',
  //   selectedLanguages: 'languages',
  //   liveStatus: 'liveStatus',
  //   textSearch: 'textSearch',
  //   favoriteFilter: 'favoriteFilter'
  // }

  // const updateField = emitString.split(':')[1]
  // const payloadKey = keyMap[updateField] || updateField
  // filterUpdatePayload[payloadKey] = items

  // this.SET_CURRENT_FILTERS(filterUpdatePayload)
}
